// extracted by mini-css-extract-plugin
export var inset = "rive-module--inset--5773a";
export var rive = "rive-module--rive--27276";